(function($) {

    // Initialize slider on mobile only
    $(window).on('load resize orientationchange', function() {
        $('.slick').slick('setPosition');
        $('.slider-side-xs').each(function() {
            var $carousel = $(this);
            console.log('side-slider');


            if (!$carousel.hasClass('slick-initialized')) {
                $carousel.slick({
                    arrows: true,
                    accessibility:false,
                    dots: false,
                    infinite: false,
                    mobileFirst: true,
                    slide: '.slider-item',
                    respondTo: 'slider',
                    responsive: [
                        {
                            breakpoint: 1830,
                            settings: {
                                arrows: true,
                                slidesToShow: 2,
                                slidesToScroll: 1
                            }
                        },
                        {
                            breakpoint: 468,
                            settings: {
                                arrows: true,
                                slidesToShow: 1,
                                slidesToScroll: 1
                            }
                        },
                        {
                            breakpoint: 250,
                            settings: {
                                arrows:true,
                                slidesToShow: 1,
                                slidesToScroll: 1
                            }
                        }
                    ]
                })

                    /*Adds inline height on slide for equal height setup*/
                    .on('setPosition', function (event, slick) {
                        slick.$slides.css('height', slick.$slideTrack.height() + 'px');
                    });
            }

        });
    });

    // Sets width of slider nested inside of tabs
    $('a[data-toggle="pill"]').on('shown.bs.tab', function(e) {
        $('.slick-slider').slick('setPosition');
    });

}(jQuery));

// Sets slider height on load*/
$(window).on('load', function() {
    $('.slick-slider').slick('setPosition');
});

